import React, { createContext, Fragment, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import $ from "jquery";
import { Modal } from "bootstrap";
import { Message } from "../constants";
import { useFlashScreen } from "./flashScreen";

const NoteAlertContext = createContext();

const useNoteAlert = () => useContext(NoteAlertContext);

const ModelAlertProvider = ({ children }) => {
  const [title, setTitle] = useState("Please Note");
  const [content, setContent] = useState(null);
  const [containerIcon, setIcon] = useState("fa-solid fa-triangle-exclamation");
  const [isCloseBtn, setIsCloseBtn] = useState(true);
  const [isCrossClose, setIsCrossClose] = useState(true);
  const [primaryButton, setPrimaryButton] = useState(null);
  const [secondaryButton, setSecondaryButton] = useState(null);
  const [closeBtnFun, setCloseBtnFun] = useState(() => null);
  const [queue, setQueue] = useState([]);
  const { showFlashScreen } = useFlashScreen();
  const [isModalActive, setIsModalActive] = useState(false);
  const [isDialogContent, setIsDialogContent] = useState(false);

  useEffect(() => {
    if (!isModalActive && queue.length > 0) {
      const nextModal = queue[0];
      setIsModalActive(true);
      setTimeout(() => processModal(nextModal), 200);
    }
    return () => {
      setIsDialogContent(false);
    };
  }, [queue, isModalActive]);

  const processModal = ({ content, title, showCloseBtn, closeFunction, popupIcon }) => {
    setTitle(title);
    setContent(content);
    setIsCloseBtn(showCloseBtn);
    setCloseBtnFun(() => () => {
      if (closeFunction) closeFunction();
    });
    if (popupIcon) {
      setIcon(popupIcon);
    } else setIcon("fa-solid fa-triangle-exclamation");
    const modalDiv = document.getElementById("notealert");
    // let popupDiv = Modal.getInstance(modalDiv);
    // if (!popupDiv) {
    const popupDiv = new Modal(modalDiv);
    // }
    if (modalDiv.classList.contains("show")) {
      popupDiv.hide();
    }
    popupDiv.show();
  };

  const showNoteAlert = (
    _content,
    _title = "Please Note",
    _showCloseBtn = true,
    closeBtnFunction = () => {},
    icon = null,
  ) => {
    setPrimaryButton(null);
    setSecondaryButton(null);
    showFlashScreen(false);
    setQueue((prevQueue) => [
      ...prevQueue,
      {
        content: _content,
        title: _title,
        showCloseBtn: _showCloseBtn,
        closeFunction: () => {
          if (typeof closeBtnFunction === "function") {
            closeBtnFunction();
          }
          hideNoteAlert();
        },
        popupIcon: icon,
      },
    ]);
  };

  const showModelAlert = ({
    content,
    title = "Please Note",
    showCloseBtn = true,
    closeBtnFunction = () => {},
    icon = null,
  }) => {
    setPrimaryButton(null);
    setSecondaryButton(null);
    showFlashScreen(false);
    setQueue((prevQueue) => [
      ...prevQueue,
      {
        content: content,
        title: title,
        showCloseBtn: showCloseBtn,
        closeFunction: () => {
          if (typeof closeBtnFunction === "function") {
            closeBtnFunction();
          }
          hideNoteAlert();
        },
        popupIcon: icon,
      },
    ]);
  };
  const showDialogAlert = ({
    content,
    title = "Please Note",
    primaryBtn = { caption: "Ok", onClick: null },
    scondaryBtn = { caption: "Close", onClick: null },
  }) => {
    showFlashScreen(false);
    setTitle(title);
    setIsDialogContent(true);
    setContent(content);
    if (primaryBtn) setPrimaryButton(primaryBtn);
    if (scondaryBtn) setSecondaryButton(scondaryBtn);

    var modalDiv = document.getElementById("notealert");
    var popupDiv = Modal.getInstance(modalDiv);
    setIsCloseBtn(false);
    if (!popupDiv) {
      popupDiv = new Modal(modalDiv);
    }
    if (!modalDiv.classList.contains("show")) {
      popupDiv.show();
    }
  };
  const showRestrictionAlert = ({
    content,
    title = "Please Note",
    showCloseBtn = true,
    closeBtnFunction = () => {},
    icon = null,
    crossButton = true,
  }) => {
    setPrimaryButton(null);
    setSecondaryButton(null);
    showFlashScreen(false);
    setIsCrossClose(crossButton);
    setQueue((prevQueue) => [
      ...prevQueue,
      {
        content: content,
        title: title,
        showCloseBtn: showCloseBtn,
        closeFunction: () => {
          if (typeof closeBtnFunction === "function") {
            closeBtnFunction();
          }
          hideNoteAlert();
        },
        popupIcon: icon,
      },
    ]);
  };

  const clearAll = () => {
    setTitle("");
    setContent("");
    setIsCloseBtn(false);
    setPrimaryButton(null);
    setSecondaryButton(null);
  };

  const hideNoteAlert = () => {
    const modalDiv = document.getElementById("notealert");
    const popupDiv = Modal.getInstance(modalDiv);
    if (popupDiv) {
      popupDiv.hide();
    }
    // Remove backdrop classes to ensure proper cleanup
    document.body.classList.remove("modal-open");
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((backdrop) => backdrop.remove());

    clearAll();
    setQueue((prevQueue) => prevQueue.slice(1));
    setIsModalActive(false);
  };

  const showAeroselProductAlert = (aeroselProduct) => {
    showNoteAlert(Message["AerosolDangerousProduct"] + "'" + aeroselProduct + "'");
  };
  const showExpressCourierNotAvailable = (aeroselProduct) => {
    showNoteAlert(Message["ExpressCourierNotAvailable"] + "'" + aeroselProduct + "'");
  };
  return (
    <NoteAlertContext.Provider
      value={{
        showNoteAlert,
        hideNoteAlert,
        showDialogAlert,
        showFlashScreen,
        showAeroselProductAlert,
        showExpressCourierNotAvailable,
        showModelAlert,
        showRestrictionAlert,
      }}
    >
      {children}
      <Fragment>
        <div
          className="modal fade"
          id="notealert"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex={-1}
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered modal-animate-center product-notfound-dialog">
            <div className="modal-content">
              {isCrossClose === true && (
                <p className="order-status-close" data-bs-dismiss="modal" onClick={hideNoteAlert}>
                  <i className="fa-regular fa-circle-xmark" />
                </p>
              )}
              <div className="modal-body p-0">
                {/* Product Not Found */}
                <div className="product-found">
                  {/* Header */}
                  <div className="product-found-title">
                    <i className={containerIcon} />
                    <h4>{title}</h4>
                  </div>
                  {/* Header */}
                  {/* Body */}
                  <div className="product-found-body error-popup-body">
                    <p className="text-center" dangerouslySetInnerHTML={{ __html: content }} />
                    {isCloseBtn === true && (
                      <div className="product-foundButton mt-4">
                        <div className="button-effect grey-btn-effect">
                          <button
                            className="btn btn-products btn-addcart"
                            data-bs-dismiss="modal"
                            onClick={closeBtnFun}
                          >
                            Close
                          </button>
                        </div>
                      </div>
                    )}
                    {isDialogContent === true && (
                      <div className="popupBtns mt-4">
                        <div className="button-effect popupBtns-two">
                          <button
                            data-bs-dismiss="modal"
                            onClick={primaryButton?.onClick}
                            className="btn btn-products theme-primary"
                          >
                            {primaryButton?.caption}
                          </button>

                          <button
                            data-bs-dismiss="modal"
                            onClick={secondaryButton?.onClick}
                            className="btn btn-products btn-unavailable"
                          >
                            {secondaryButton?.caption}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    </NoteAlertContext.Provider>
  );
};
export { NoteAlertContext, useNoteAlert, ModelAlertProvider };
